import "./StarterPackage.module.css";
import Header from "@/reusable_sections/Header";
import StarterPackageHero from "./sections/StarterPackageHero";
import PackageFeatures from "./sections/PackageFeatures";
import PricingCallToAction from "./sections/PricingCallToAction";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function StarterPackagePage() {
  return <div>
      <Header />
      <StarterPackageHero />
      <PackageFeatures />
      <PricingCallToAction />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}